import type { IRequestMessage } from './RequestMessageContainer';
import { FormLabel, FormParagraph, FormSubHeader, FullName } from '../../elements/common';
import { FormRow } from '../../elements/forms/FormRow';
import { HorizontalFormGroupRead } from '../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../elements/forms/InputContainer';
import { NullableFormattedDatetime } from '../../elements/NullableFormattedDatetime';

interface IRequestMessageProps {
    requestMessage: IRequestMessage;
}

export function RequestMessage({ requestMessage }: IRequestMessageProps) {
    return (
        <div className="container">
            <FormRow>
                <FormSubHeader>
                    Bericht van <FullName {...requestMessage.employment.practitioner} />
                </FormSubHeader>
            </FormRow>

            <HorizontalFormGroupRead noMargin>
                <FormLabel>
                    <NullableFormattedDatetime value={requestMessage.created_at} />
                </FormLabel>
                <InputContainer>
                    <FormParagraph>{requestMessage.message}</FormParagraph>
                </InputContainer>
            </HorizontalFormGroupRead>
        </div>
    );
}
